import { useMemo } from 'react';
import { useIntl, IntlShape, defineMessages } from 'react-intl';

import { IJourney } from '@/modules/journey/model';
import { DescriptionList } from '@/shared/view/DescriptionList';

import s from './styles.module.css';

const formatDate = ({ date, timezone, intl }: { date: Date; timezone?: string; intl: IntlShape }) =>
  intl.formatDate(date, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZone: timezone,
  });

const messages = defineMessages({
  asap: {
    defaultMessage: 'ASAP',
    id: 'hGcAWJ',
    description: 'Journey screen: ASAP journey type',
  },
  reservation: {
    defaultMessage: 'Reservation',
    id: '9i7q+r',
    description: 'Journey screen: Reservation journey type',
  },
});

const mapToHeader = (journey: IJourney, intl: IntlShape) => ({
  completedAt: journey.completedAt
    ? formatDate({ date: journey.completedAt, intl, timezone: journey.timezone })
    : null,
  type: journey.isASAP
    ? intl.formatMessage(messages.asap)
    : `${intl.formatMessage(messages.reservation)}, ${formatDate({
        // @ts-expect-error Type 'Date | undefined' is not assignable to type 'Date'
        date: journey.pickupAt,
        intl,
        timezone: journey.timezone,
      })}`,
});

type TTitleLine = [keyof ReturnType<typeof mapToHeader>, string];

const HeaderDetails = ({ journey }: { journey: IJourney }) => {
  const intl = useIntl();

  const titles = useMemo(
    (): Array<TTitleLine> => [
      [
        'completedAt',
        intl.formatMessage({
          defaultMessage: 'Completed at',
          id: 'LFleTx',
          description: 'Journey screen: Completed at field title',
        }),
      ],
      [
        'type',
        intl.formatMessage({
          defaultMessage: 'Type',
          id: 'lWlj+k',
          description: 'Journey screen: Type field title',
        }),
      ],
    ],
    [intl],
  );

  const values = useMemo(() => mapToHeader(journey, intl), [journey, intl]);

  return <DescriptionList titles={titles} values={values} className={s.details} />;
};

export { HeaderDetails };
